import { api } from '../utils/api';

// Fetch all cakes
export const fetchCakes = async () => {
  try {
    const data = await api.get('/cakes.php');
    
    console.log('Raw API response:', JSON.stringify(data).substring(0, 500));
    console.log('data.success:', data.success);
    console.log('data.data:', data.data);
    console.log('data.data.cakes:', data.data?.cakes);
    
    if (data.success && data.data && data.data.cakes) {
      console.log('Returning cakes:', data.data.cakes.length);
      return data.data.cakes;
    }
    
    console.log('No cakes found in response, returning empty array');
    return [];
  } catch (error) {
    console.error('Error fetching cakes:', error);
    return [];
  }
};

// Fetch all addons
export const fetchAddons = async () => {
  try {
    const data = await api.get('/addons.php');
    
    if (data.success) {
      return data.data.addons || [];
    }
    return [];
  } catch (error) {
    console.error('Error fetching addons:', error);
    return [];
  }
};

// Fetch categories with hierarchical structure
export const fetchCategories = async () => {
  try {
    const data = await api.get('/categories.php');
    
    console.log('Categories API response:', data);
    
    if (data.success && data.data && data.data.hierarchical) {
      // Return hierarchical categories (includes subcategories)
      return data.data.hierarchical;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};

// Get unique categories from cakes
export const getCategoriesFromCakes = (cakes) => {
  const categoryMap = new Map();
  
  cakes.forEach(cake => {
    if (cake.category_id && cake.category_name) {
      categoryMap.set(cake.category_id, {
        id: cake.category_id,
        name: cake.category_name
      });
    }
  });
  
  return Array.from(categoryMap.values());
};

// Filter cakes by category
export const filterCakesByCategory = (cakes, categoryId) => {
  if (categoryId === 'all') return cakes;
  return cakes.filter(cake => cake.category_id === parseInt(categoryId));
};

// Get cake by ID
export const getCakeById = (cakes, id) => {
  return cakes.find(cake => cake.id === parseInt(id));
};

// Get image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `https://panel.supplebakes.com/${imagePath}`;
};
